export const clean = ()=> {
        const rowsHeight = ()=> {
            const rows = document.querySelectorAll('.clean__table-row')
            const cells = document.querySelectorAll('.clean__table-cell')

            rows?.forEach((row)=> {
                row.style.height = 'unset';
            })

            const arrayHeights = Array.from(rows).map(row => {
                return row.getBoundingClientRect().height
            })

            const highest = Math.max.apply(null, arrayHeights);

            rows?.forEach((item)=> {
                item.style.height = highest + 'px';
            })
            cells?.forEach((cell)=> {
                cell.style.height = highest + 'px';
            })

        }
        const headHeight = ()=> {
            const heads = document.querySelectorAll('.clean__table-head')

            heads?.forEach((head)=> {
                head.style.height = 'unset';
            })

            const arrayHeights = Array.from(heads).map(head => {
                return head.getBoundingClientRect().height
            })

            const highest = Math.max.apply(null, arrayHeights);

            heads?.forEach((item)=> {
                item.style.height = highest + 'px';
            })

        }
        const cleanPlus = ()=> {
            const tableSections = document.querySelectorAll('.clean__table-section-heading')
            const plusTable = document.querySelector('.clean__table-plus')

            const arrayHeights = Array.from(tableSections).map(section => {
                return section.getBoundingClientRect().height
            })

            const highest = Math.max.apply(null, arrayHeights);

            if (plusTable) {
                plusTable.style.marginTop = `${highest}px`
            }
        }

        cleanPlus()
        headHeight();
        rowsHeight();

        addEventListener('resize',()=> {
            headHeight();
            rowsHeight();
            cleanPlus()
        })
}